var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBubbles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "945px",
    height: "945px",
    viewBox: "0 0 945 945",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Bubbles") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bubbles",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background",
    transform: "translate(0.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M676,167 C676,171.97048 671.973154,176 667,176 C662.026846,176 658,171.97048 658,167 C658,162.02952 662.026846,158 667,158 C671.973154,158 676,162.02952 676,167",
    id: "Fill-399",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638,9 C638,13.9704797 633.973154,18 629,18 C624.026846,18 620,13.9704797 620,9 C620,4.0295203 624.026846,0 629,0 C633.973154,0 638,4.0295203 638,9",
    id: "Fill-400",
    fill: "#EAE8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M945,422.998994 C945,427.97048 940.965344,432 935.994969,432 C931.024595,432 927,427.97048 927,422.998994 C927,418.02952 931.024595,414 935.994969,414 C940.965344,414 945,418.02952 945,422.998994",
    id: "Fill-401",
    fill: "#EAE8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,84.0005032 C195,88.970705 190.970705,93 186.000503,93 C181.029295,93 177,88.970705 177,84.0005032 C177,79.029295 181.029295,75 186.000503,75 C190.970705,75 195,79.029295 195,84.0005032",
    id: "Fill-403",
    fill: "#EAE8F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,425.998994 C18,430.97048 13.9704797,435 9,435 C4.0295203,435 0,430.97048 0,425.998994 C0,421.02952 4.0295203,417 9,417 C13.9704797,417 18,421.02952 18,425.998994",
    id: "Fill-402",
    fill: "#EAE8F2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/Bubbles.435fb2d48912b40d899605d5dd6d274a.svg";
export { ForwardRef as ReactComponent };